import request from '../../utils/request'
//获取证书资质列表
export function getCertificateList(query) {
  return request({
    url: '/companyAbout/certificate-list',
    method: 'get',
    params: query
  })
}
//获取历程
export function getHistoryList(query) {
  return request({
    url: '/companyAbout/history',
    method: 'get',
    params: query
  })
}
//获取工程案例
export function getRelatedByCase(query) {
  return request({
    url: '/companyAbout/relatedByCase',
    method: 'get',
    params: query
  })
}
//获取工程案例详情
export function getRelatedDetails(query) {
  return request({
    url: `/companyAbout/related/${query}`,
    method: 'get',
  })
}
//获取企业文化
export function getRelatedByCulture() {
  return request({
    url: '/companyAbout/relatedByCulture',
    method: 'get',
  })
}
//获取检测能力
export function getRelatedByDetection() {
  return request({
    url: '/companyAbout/relatedByDetection',
    method: 'get',
  })
}
//获取信息公开
export function getRelatedByInfo(query) {
  return request({
    url: '/companyAbout/relatedByInfo',
    method: 'get',
    params: query
  })
}
//获取企业简介
export function getRelatedByIntro() {
  return request({
    url: '/companyAbout/relatedByIntro',
    method: 'get',
  })
}
//获取网站信息
export function getWebInfo() {
  return request({
    url: '/webinfo/info',
    method: 'get',
  })
}
//提交咨询信息
export function getConsultSubmit(query) {
  return request({
    url: '/consult/submit',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/assets/api/about.js